export const engagementCanvasTemplatePreview = "/engagement/:app_group_id/structural_template/canvas_template/:id";
